export function checkForIsSignedAllConsents(appointment) {
  const allAppointmentConsentEntity = appointment
    ? appointment.consentsAssignment
    : null;

  const allConsents = allAppointmentConsentEntity
    ? allAppointmentConsentEntity.consents
    : [];
  return allConsents.every(({ accepted }) => !!accepted);
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/utils/checkForIsSignedAllConsents.js